import $axios from './api';

export const list = async (payload = {}) => {

	const { data } = await $axios.post('/v1/author/referral/list', payload);
	return data;

};

export const actionsList = async (payload = {}) => {

	const { data } = await $axios.post('/v1/author/referral/actions/list', payload);
	return data;

};
